import React, { Component } from 'react';
import createHistory from 'history/createBrowserHistory';
import {Route, Router} from "react-router-dom";



import Graphic from './page/graphic/Graphic';
import Menu from './page/menu/Menu';
import About from './page/about/About';
import Web from './page/web/Web';
import Contact from './page/contact/Contact';


import './App.css';
import './css/bootstrap.min.css';
import './css/flexslider.css';
import './css/jquery.fancybox.css';
import './css/main.css';
import './css/responsive.css';
import './css/animate.min.css';
import './css/font-icon.css';





const history = createHistory();

class App extends Component {
  render() {
    return (

        <Router history={history}>

          <div className="App">
          <Menu/>

              <Route exact path="/" component={About}/>
              <Route  path="/graphic" component={Graphic}/>
              <Route  path="/web" component={Web}/>
              <Route path="/contact" component={Contact}/>
          </div>
        </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js